<template>
    <Path>
        <template v-slot:path>
            <li><router-link :to="{name: 'dashboard'}" >الصفحة الرئيسية</router-link> </li>
            <li> <span class="divider"> / </span><a href="#">الاسئلة الشائعة </a> </li>        
        </template>
    </Path>

    <section>
        <div class="py-4 ">
            <div class="container">
                <div class="row">
                    <div class="col-12 mb-2 ">
                        <h1 class="blueFont py-3">الأسئلة الشائعة</h1>
                        <div class="accordion" id="accordionExample">
                            <div class="accordion-item">
                                <h2 class="accordion-header" id="headingOne">
                                    <button style="text-align: right;" class="accordion-button  shadow-sm border rounded-3 my-4" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne"
                                        aria-expanded="false" aria-controls="collapseOne">
                                    1-      هل يمكن تغيير بيان فى شهاده ميلاد اوبطاقه ؟
                                    </button>
                                </h2>
                                <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne"
                                    data-bs-parent="#accordionExample">
                                    <div class="accordion-body">
                                        ناسف عن تلبيه هذه الخدمه عن طريق الانترنت حيث ان هذه الخدمه تتطلب تقديم مستندات ويمكنكم التقدم للادارة اواقرب سجل مدنى تابع لمحل لسكنكم  لتلبيه هذه الخدمه ومعكم المستندات الداله على التغيير
                                    </div>
                                </div>
                            </div>

                            <div class="accordion-item">
                                <h2 class="accordion-header" id="headingTwo">
                                    <button style="text-align: right;" class="accordion-button  shadow-sm border rounded-3 my-4 collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                    2-     هل يوجد اسلوب اخر للدفع غير بطاقات الائتمان ؟
                                    </button>
                                </h2>
                                <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo"
                                    data-bs-parent="#accordionExample">
                                    <div class="accordion-body">
                                        الخدمه متاحه عن طريق جميع البطاقات الائتمانيه ( فيزا ) ماستر كارد المصدره من اى بنك أو الدفع من خلال خدمة فورى
                                    </div>
                                </div>
                            </div>

                            <div class="accordion-item">
                                <h2 class="accordion-header" id="headingThree">
                                    <button style="text-align: right;" class="accordion-button  shadow-sm border rounded-3 my-4 collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                        3-  هل يمكن استخراج شهادة قيد وفاه وبيان قيد عائلى عبر الانترنت؟
                                    </button>
                                </h2>
                                <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree"
                                    data-bs-parent="#accordionExample">
                                    <div class="accordion-body">
                                        نعم يمكن أستخراج صورة قيد وفاة مميكن وكذا صورة قيد (زواج - طلاق - قيد عائلى مميكن ثانى مرة)
                                    </div>
                                </div>
                            </div>

                            <div class="accordion-item">
                                <h2 class="accordion-header" id="headingfour">
                                    <button style="text-align: right;" class="accordion-button  shadow-sm border rounded-3 my-4 collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapsefour" aria-expanded="false" aria-controls="collapsefour">
                                        4-   اسعار الخدمه عن طريق الموقع مبالغ فيها؟
                                    </button>
                                </h2>
                                <div id="collapsefour" class="accordion-collapse collapse" aria-labelledby="headingfour"
                                    data-bs-parent="#accordionExample">
                                    <div class="accordion-body">
                                        يتم تقديم الخدمه تحت بند الخدمات المميزه واسعار الخدمه عن طريق الموقع أقل من اسعار الخدمه ذاتها اذا تم طلبها " مستعجل " من مقر القطاع او من اى المواقع التابعة لها
                                    </div>
                                </div>
                            </div>
									
                            <div class="accordion-item">
                                <h2 class="accordion-header" id="headingfive">
                                    <button style="text-align: right;" class="accordion-button  shadow-sm border rounded-3 my-4 collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapsefive" aria-expanded="false" aria-controls="collapsefive">
                                        5-  هل يمكن الاستفادة من خدمة الانترنت للمصريين المقيمين خارج جمهورية مصر العربية ؟
                                    </button>
                                </h2>
                                <div id="collapsefive" class="accordion-collapse collapse" aria-labelledby="headingfive"
                                    data-bs-parent="#accordionExample">
                                    <div class="accordion-body">
                                        لا يمكن استخراج بطاقة رقم قومى لمواطن خارج جمهورية مصر العربية من خلال خدمة الانترنت	
                                    </div>
                                </div>
                            </div>
                            
						    <div class="accordion-item">
                                <h2 class="accordion-header" id="headingsix">
                                    <button style="text-align: right;" class="accordion-button  shadow-sm border rounded-3 my-4 collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapsesix" aria-expanded="false" aria-controls="collapsesix">
                                        6- هل الدفع بالبطاقات الائتمانيه يكون عن طريق بطاقات البنك الاهلى المصرى فقط؟
                                    </button>
                                </h2>
                                <div id="collapsesix" class="accordion-collapse collapse" aria-labelledby="headingsix"
                                    data-bs-parent="#accordionExample">
                                    <div class="accordion-body">
                                    الخدمه متاحه عن طريق جميع البطاقات الائتمانيه فيزا - ماستر كارد المصدره من اى بنك  ومن خلال خدمة فورى
                                    </div>
                                </div>
                            </div>

                            <div class="accordion-item">
                                <h2 class="accordion-header" id="headingseven">
                                    <button style="text-align: right;" class="accordion-button  shadow-sm border rounded-3 my-4 collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapseseven" aria-expanded="false" aria-controls="collapseseven">
                                7- هل تم تحديد موعد لتسليم المستندات ؟                                           
                                </button>
                                </h2>
                                <div id="collapseseven" class="accordion-collapse collapse" aria-labelledby="headingseven"
                                    data-bs-parent="#accordionExample">
                                    <div class="accordion-body">
                                    يتم تسليم المستندات خلال 48  ساعة داخل القاهرة الكبرى  و 72 ساعه  للمحافظات  من اجراء الطلب  وفى حاله عدم وجود مقدم الطلب فى مكان الاستلام فانه يتم الاتصال هاتفيا ثلاث مرات لتحديد موعد اخر . اما فى حاله عدم استقبال المكالمه فانه على مقدم الطلب التوجه الى قطاع الاحوال المدنيه بالعباسيه وذلك لاستلام الطلب او المستندات من مقر القطاع
                                    </div>
                                </div>
                            </div>
									
							<div class="accordion-item">
                                <h2 class="accordion-header" id="headingeight">
                                    <button style="text-align: right;" class="accordion-button  shadow-sm border rounded-3 my-4 collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapseeight" aria-expanded="false" aria-controls="collapseeight">
                                8- هل يمكن استخراج بطاقة رقم قومى للمره الاولى عن طريق الموقع ؟                                           
                                </button>
                                </h2>
                                <div id="collapseeight" class="accordion-collapse collapse" aria-labelledby="headingeight"
                                    data-bs-parent="#accordionExample">
                                    <div class="accordion-body">	
                                    لا يمكن استخراج بطاقه رقم قومى للمره الاولى من خلال موقع القطاع  لان من شروط استخراج بطاقة رقم قومى لاول مرة يلزم التصوير من خلال الذهاب للسجل المدنى التابع لمحل السكن 
                                    </div>
                                </div>
                            </div>

							<div class="accordion-item">
                                <h2 class="accordion-header" id="headingnine">
                                    <button style="text-align: right;" class="accordion-button  shadow-sm border rounded-3 my-4 collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapsenine" aria-expanded="false" aria-controls="collapsenine">
                                9- هل يمكن اصدار شهادة الميلاد لغير الحاصلين على بطاقة الرقم القومى ؟
                                </button>
                                </h2>
                                <div id="collapsenine" class="accordion-collapse collapse" aria-labelledby="headingnine"
                                    data-bs-parent="#accordionExample">
                                    <div class="accordion-body">	
                                    نعم يمكن اصدار شهادة ميلاد مميكنة لغير الحاصلين على بطاقة رقم قومى بشرط استخراج شهادة ميلاد مميكنة من قبل
                                    </div>
                                </div>
                            </div>

							<div class="accordion-item">
                                <h2 class="accordion-header" id="headingten">
                                    <button style="text-align: right;" class="accordion-button  shadow-sm border rounded-3 my-4 collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapseten" aria-expanded="false" aria-controls="collapseten">
                            10- هل يوجد رقم قومى لمن هم اقل من 16 سنه ؟
                                </button>
                                </h2>
                                <div id="collapseten" class="accordion-collapse collapse" aria-labelledby="headingten"
                                    data-bs-parent="#accordionExample">
                                    <div class="accordion-body">	
                                نعم يوجد رقم قومى لمن هم اقل من 16 سنه وانه بمجرد تسجيل تبليغات المواليد الوارده من وزارة الصحة على الحاسب الالى يتم تكوين رقم قومى لاى مولود
                                    </div>
                                </div>
                            </div>

							<div class="accordion-item">
                                <h2 class="accordion-header" id="headingeleven">
                                    <button style="text-align: right;" class="accordion-button  shadow-sm border rounded-3 my-4 collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapseeleven" aria-expanded="false" aria-controls="collapseeleven" >
                            11- هل يمكن استخراج شهادات الميلاد لاى شخص عن طريق السفاره المصريه للمصرين العاملين بالخارج؟
                                </button>
                                </h2>
                                <div id="collapseeleven" class="accordion-collapse collapse" aria-labelledby="headingeleven"
                                    data-bs-parent="#accordionExample">
                                    <div class="accordion-body">	
                                يمكن استخراج شهادات الميلاد لاى شخص عن طريق السفاره - حيث تقوم السفاره بتلقى الطلب وارساله لقطاع الاحوال المدنيه بجمهوريه مصر العربيه حيث يتم استخراج الشهاده المطلوبه واعاده ارساله للسفاره من خلال وزاره الخارجيه
                                    </div>
                                </div>
                            </div>

							<div class="accordion-item">
                                <h2 class="accordion-header" id="headingtweleve">
                                    <button style="text-align: right;" class="accordion-button  shadow-sm border rounded-3 my-4 collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapsetweleve" aria-expanded="false" aria-controls="collapsetweleve">
                            12- هل تكون هناك مدة محددة لسريان بطاقة الرقم القومى ؟
                                </button>
                                </h2>
                                <div id="collapsetweleve" class="accordion-collapse collapse" aria-labelledby="headingtweleve"
                                    data-bs-parent="#accordionExample">
                                    <div class="accordion-body">	
                                نعم لقد اصدر السيد حبيب العادلى وزير الداخلية قرارا بان تكون مدة سريان بطاقة الرقم القومى "سبع سنوات"من تاريخ استخراجها ويتم تجديدها خلال ثلاثة اشهر من تاريخ انتهاء تلك المدة000 على ان يبدا التنفيذ اعتبارا من 1/1/2009م
                                    </div>
                                </div>
                            </div>

							<div class="accordion-item">
                                <h2 class="accordion-header" id="headingtthirteen">
                                    <button style="text-align: right;" class="accordion-button  shadow-sm border rounded-3 my-4 collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapsethirteen" aria-expanded="false" aria-controls="collapsethirteen">
                            13- هل يمكن اصدار بطاقة بدل فاقد - تالف من الانترنت بعد مرور سبع سنوات على اصدار البطاقة؟
                                </button>
                                </h2>
                                <div id="collapsethirteen" class="accordion-collapse collapse" aria-labelledby="headingtthirteen"
                                    data-bs-parent="#accordionExample">
                                    <div class="accordion-body">	
                                لا يمكن اصدار بطاقة رقم قومى بدل فاقد- تالف من الانترنت بعد مرور سبع سنوات على اصدار البطاقة ويلزم الذهاب للسجل التابع له للتصوير للمواطن تحت سن ال60 عام ويستثنى من ذلك الاكثر من 60 سنة يمكنة اصدار بطاقة بدل فاقد-تالف من الانترنت بدون تصوير قبل مرور ثلاثة اشهر على الانتهاء 
                                    </div>
                                </div>
                            </div>		  
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
 
</template>

<script>
import Path from '@/components/Path.vue'
export default {
   name: 'QuestionsComp',
   components:{Path},
   created(){
    window.scrollTo({ top: 0, behavior: "smooth" });
  },
  }
</script>